import { TAny } from '_/types/common.types';

export const EMPTY_OBJECT: Readonly<Record<string, TAny>> = Object.freeze<Record<string, TAny>>({});

export const DOCS_DOMAIN = 'https://doc-docs.import.io';

export const BATCH_JOB_BASE_URL = 'https://us-east-2.console.aws.amazon.com/batch/v2/home?region=us-east-2#jobs/detail';
